
/**
 * @module mapbs.components.displayquerywindow.displayquerywindow
*/
import angular from 'angular';
import { transform } from 'ol/proj';
import GmfDisplayquerywindowController from 'gmf/query/windowComponent.js';

const moduleDisplayQueryWindow = angular.module('mapbsDisplayQueryWindowModule', [
    GmfDisplayquerywindowController.name
]);

moduleDisplayQueryWindow.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/displayquerywindow', require('./displayquerywindow.html'));
    }
);

/** @type {!angular.Component} */
const DisplayQueryWindowComponent = {
    controller: 'mapbsDisplayQueryWindowController as ctrl',
    templateUrl: 'mapbs/displayquerywindow',
    bindings: {
    },
};

moduleDisplayQueryWindow.component('mapbsDisplayQueryWindow', DisplayQueryWindowComponent);

class DisplayQueryWindowController {
    /**
     * @constructor
     * @param {angular.Scope} $scope
     * @private
     * @ngInject
     */
    constructor() {
        /**
         * @type {Array<Object>}
         */
        this.queryData = [];

        /**
         * @type {boolean}
         */
        this.isVisible = false;

        /**
         * @type {string}
         */
        this.activeQuery = '';
    }

    showCoordinats(ctrl) {
        const geometryField = ctrl.feature.geometryName_;
        const coord = transform(
            /** @type {Array<number>} */ (ctrl.feature.values_[geometryField].flatCoordinates),
            'EPSG:2056',
            'EPSG:4326'
        );
        const y = coord[0];
        const x = coord[1];
        const url = `https://opendatabs.github.io/map-links/?lat=${x}&lon=${y}`;
        window.open(url, '_blank');
    }

}

moduleDisplayQueryWindow.controller('mapbsDisplayQueryWindowController', DisplayQueryWindowController);

export default moduleDisplayQueryWindow;
